export default __webpack_public_path__ + "static/media/briefCase.bb5e9046.svg";